module.exports = __webpack_public_path__ + "static/media/trim-warez-t.44c168bd.png";